/**
 * Shares the analytics join keys (`context_id`, `organization_id`) with deeply
 * nested chat children — notably message bubbles — so post-answer interactions
 * (link clicks, copies) can be attributed to the right conversation and joined
 * to backend OpsPilot traces without prop-drilling through every component.
 *
 * Outside a provider the hook returns empty keys, so components stay renderable
 * in isolation (e.g. Storybook, unit tests) without an analytics wrapper.
 */
import { createContext, useContext, type PropsWithChildren } from 'react';

type ChatTrackingValue = {
  context_id?: string;
  organization_id?: string;
};

const ChatTrackingContext = createContext<ChatTrackingValue>({});

export const ChatTrackingProvider = ({
  value,
  children,
}: PropsWithChildren<{ value: ChatTrackingValue }>) => (
  <ChatTrackingContext.Provider value={value}>
    {children}
  </ChatTrackingContext.Provider>
);

export const useChatTracking = (): ChatTrackingValue =>
  useContext(ChatTrackingContext);
